module.exports = __webpack_public_path__ + "static/img/shoppic.00a9076.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shoppic.jpg
// module id = 65Jj
// module chunks = 1